import React from "react"
import { graphql, Link } from "gatsby"
import RecentBlogsBlob from "../components/recentblogsblob"
import RecentImageBlob from "../components/recentimageblob"
import Layout from "gatsby-theme-wirehead-bulma/src/layout"
import FrontPageBillboard from "../components/frontpagebillboard"
import SEO from "gatsby-theme-wirehead-bulma/src/seo"

const PostLink = ({ post }) => {
  return (
    <li><Link to={post.node.path} key={post.node.path}>
      {post.node.context.title}
    </Link></li>
  )
}

const IndexPage = ({
  pageContext,
  location,
}) => {
  return (<Layout>
    <SEO title="Wirehead Arts" pathname={location.pathname} />
    <section className="section">
    <div className="columns">
      <div className="column content is-size-4">
        <p>Wirehead Arts is devoted to the landscape, night, portrait, art, and infrared photography, plus the pottery and sculpture of Ken Wronkiewicz, a San Francisco Bay Area based artist and artistic hacker, as well as writings about the techniques of art.</p>

        <p>His photography includes landscapes all around the world - both during the day and at night, work with a variety of models, unique lighting techniques, and things he found interesting.</p>
      </div>
      <div className="column">
        <div className="box" style={{"background": "#fff"}}>
        <FrontPageBillboard />
        </div>
      </div>
    </div>
    <div className="columns">
      <div className="column">
        <aside>
          <h3>Recent Blog Posts:</h3>
          <RecentBlogsBlob />
        </aside>
      </div>
      <div className="column is-clearfix">
        <aside>
          <h3>Recent Images:</h3>
          <RecentImageBlob />
        </aside>
      </div>
    </div>
    </section>
  </Layout>);
}

export default IndexPage